/**
 * @description Затащить шаги.
 * @type {string}
 */
export const FETCH_STEPS = 'FETCH_STEPS';

/**
 * @description Установить шаги.
 * @type {string}
 */
export const SET_STEPS = 'SET_STEPS';

/**
 * @description Установить доступ к просмотру ОнБординга.
 * @type {string}
 */
export const SET_ALLOW_SHOW = 'SET_ALLOW_SHOW';

/**
 * @description Установить новый элемент в хранилище
 * @type {string}
 */
export const SET_ELEMENT = 'SET_ELEMENT';

/**
 * @description Установить заголовок
 * @type {string}
 */
export const SET_TITLE = 'SET_TITLE';
